<template>
  <CenteredLayout>
    <v-row no-gutters justify="center" style="width: 100%">
      <v-card :width="formWidth">
        <v-card-title class="word-break">{{
          $t("views.trustedThirdParty.title")
        }}</v-card-title>
        <v-card-text>
          <template v-if="loading">
            {{ $t("views.trustedThirdParty.loadingAuth") }}
          </template>
          <template v-else-if="success">
            {{ $t("views.trustedThirdParty.authSuccess") }}
          </template>
          <template v-else>
            {{ $t("views.trustedThirdParty.authError") }}
          </template>
        </v-card-text>

        <v-progress-linear
          :indeterminate="loading || success"
          :color="loading || success ? 'primary' : 'error'"
          :value="!loading && !success ? '100' : undefined"
        ></v-progress-linear>
      </v-card>
    </v-row>
    <v-row id="bottom-logo" no-gutters class="mt-4 mt-md-0">
      <v-col
        cols="12"
        v-bind:class="[
          $vuetify.breakpoint.mdAndUp ? 'text-right' : 'text-center',
        ]"
      >
        <a href="https://www.juntadeandalucia.es/" target="_blank">
            <img
              v-bind:class="[(error ? 'logo ma-1' : 'logo ma-2')]"
              alt="Junta logo"
              src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/sites/default/files/repositorio/2025-11/logo-junta.svg"
              :style="[
                { marginRight: '0px !important' },
                $vuetify.breakpoint.mdAndUp
                  ? { maxHeight: '60px' }
                  : { maxHeight: '40px' }
              ]"
            />
          </a>
        <a href="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/" target="_blank">
          <img
            v-bind:class="[(error ? 'logo ma-1' : 'logo ma-2')]"
            alt="SAS logo"
            src="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/repositorio/logotipo-sas"
            :style="[
              { marginLeft: '0px !important' },
              $vuetify.breakpoint.mdAndUp
                ? { maxHeight: '60px' }
                : { maxHeight: '40px' }
            ]"
          />
        </a>
      </v-col>
    </v-row>
  </CenteredLayout>
</template>

<script>
import { mapState } from 'vuex';
import { CenteredLayout } from '@/layouts';
import { STATUS as SESSION_STATUS } from '@/store/modules/session';

export default {
  components: { CenteredLayout },
  props: {
    tempCode: String,
  },
  computed: {
    formWidth() {
      return this.$vuetify.breakpoint.mobile ? '90%' : '500px';
    },
    ...mapState({
      loading: ({ session: { status } }) => status === SESSION_STATUS.LOADING,
      success: ({ session: { status } }) => status === SESSION_STATUS.SUCCESS,
    }),
  },
  methods: {
    auth() {
      this.$store
        .dispatch('session/trustedThirdPartyAuth', this.tempCode)
        .then((session = {}) => {
          if (typeof session.redirect === 'string') {
            // eslint-disable-next-line prefer-destructuring
            let redirect = session.redirect;
            if (!redirect.startsWith('/')) {
              redirect = `/${redirect}`;
            }
            this.$router.push(redirect);
          }
        })
        .catch((err) => {
          const errorCode = this.$store.getters['session/errorCode'] || 'unkown';
          // this.errorMessages.push(this.$t(`views.login.error.${errorCode}`));
          if (errorCode === 'unkown') {
            console.error('unexpected error occurred during auth method', err);
          }
        });
    },
  },
  async mounted() {
    this.auth();
  },
};
</script>

<style lang="scss" scoped>
img.logo {
  max-width: 100%;
}

.word-break {
  word-break: break-word;
}
</style>

<style lang="scss">
@media (min-width: 960px) {
  #bottom-logo {
    position: absolute;
    left: 12px;
    right: 12px;
    bottom: 0;
  }
}
</style>
